import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCKingKnut extends NPC {
    constructor() {
        super(definitions.NPC_ID.KING_KNUT);

        this.collisionRadius = 24;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -34;

        this.playerRespawnPos.x = 150;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_king_knut_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(5, -8));
        this.animateIdle(1);
    }
}